import { Asset } from 'app-lib/assetUtils'
import React, { Component } from 'react'
import { Button, InfoTip } from 'ui-framework'

export interface IPriceSwitchProps {
  loanAsset: Asset
  collateralAsset: Asset
  selectedAsset: Asset
  textTooltip?: string
  onAssetChange?: (asset: Asset) => void
}

export interface IPriceSwitchState {
  isOpened: boolean
}

export default class PriceSwitch extends Component<IPriceSwitchProps, IPriceSwitchState> {
  constructor(props: IPriceSwitchProps) {
    super(props)

    this.state = { isOpened: false }
  }

  public componentDidUpdate(
    prevProps: Readonly<IPriceSwitchProps>,
    prevState: Readonly<IPriceSwitchState>
  ): void {
    if (prevState.isOpened !== this.state.isOpened) {
      if (document.querySelector('.price-switch__wrapper')) {
        const PriceSwitchSelector = document.querySelector('.price-switch__wrapper') as HTMLElement
        const boundingClient = PriceSwitchSelector.getBoundingClientRect()
        PriceSwitchSelector!.style.left = -1 * boundingClient!.left + 'px'
      }
    }
  }

  private onSelect = (asset: Asset) => {
    if (this.props.onAssetChange) {
      this.props.onAssetChange(asset)
    }
    this.onClose()
  }

  private onClose = () => {
    this.setState({ ...this.state, isOpened: false })
  }

  public render() {
    const unselectedAsset =
      this.props.selectedAsset === this.props.loanAsset
        ? this.props.collateralAsset
        : this.props.loanAsset

    return (
      <div className="price-switch-container">
        {this.state.isOpened ? (
          <div className="price-switch__wrapper" onClick={this.onClose} />
        ) : null}
        <div className="price-switch-container">
          <Button
            variant="invisible"
            className={`price-switch-button ${this.state.isOpened ? 'opened' : 'closed'}`}
            onClick={() => this.onSelect(unselectedAsset)}>
            <span className="margin-right-1ch">
              {this.props.selectedAsset}/{unselectedAsset}
            </span>
            <InfoTip id="price-switch-tip" icon="switch">
              <p>Click to toggle quote currency. {`${this.props.textTooltip || ''}`}</p>
            </InfoTip>
          </Button>
          {this.state.isOpened ? (
            <div className="price-switch">
              <div className="price-switch__items">
                <div className="price-switch-item" onClick={() => this.onSelect(unselectedAsset)}>
                  <div className="price-switch-item__description-container">
                    <div className="txt-alternate txt-default">
                      {unselectedAsset}/{this.props.selectedAsset}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}
